<template>
    <section class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-md-2 col-lg-2">
                <div class="control-wrapper">
                    <h3>Choose a screen library</h3>
                        <select class="l"></select>
                </div>
                <div class="control-wrapper">
                    <h3>Choose scatter plot data</h3>
                    <h5>X Axis</h5>
                
                    <div class="select-wrapper">
                        <div class="select-title">Condition</div>
                        <select class="c"></select>
                    </div>
                    <div class="select-wrapper">
                        <div class="select-title">Model</div>
                        <select class="cl"></select>
                    </div>
                </div>
                <div class="control-wrapper">
                    <h5>Y Axis</h5>
                    <div class="btn-group" role="group" aria-label="">
                        <button type="button" class="btn btn-outline-primary scatterplotType"
                            value="false">Volcano</button>
                        <button type="button" class="btn btn-outline-primary scatterplotType"
                            value="true">Comparison</button>
                    </div>
                </div>
                <div class="control-wrapper">
                    <div class="dispayNone" id="comparison-menu">
                        <div class="select-wrapper">
                            <div class="select-title">Condition</div>
                            <select class="c2"></select>
                        </div>
                        <div class="select-wrapper">
                            <div class="select-title">Model</div>
                            <select class="cl2"></select>
                        </div>
                    </div>
                </div>
                        <p id="plot-instructions"></p>  
                    </div>

                    <div class="col-sm-12 col-md-4 col-lg-4">
                        <div id="focus-plot">
                            <div id="focus-plot-tooltip" class="hidden"></div>
                        </div>
                        <table id="table" class="cell-border"></table>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div id="context-plots">
                         
                        </div>
                    </div>
        </div>
        <div id="context-plots-tooltip" class="hidden"></div>
    </section>
    
</template>

<script>

import * as tideDataPortal from '../js/mainView.js';

    const dict = {
        "cellLine": {
            "B": "B16",
            "C": "CT26",
            "K": "KPC",
            "L": "LLC",
            "M": "MC38",
            "P": "Panc02",
            "R": "Renca",
            "Y": "Yummer"
        },
        "screenLibrary": {
            "g": "Genome",
            "p": "Subgenome",
            "c": "Chromatin regulator"
        },
        "condition": {
            "IN": "Input",
            "OUT": "Output",
            "NSG": "NSG",
            "WT": "WT",
            "IO": "ICB"
        },
        "conditionPair": {
            "IN": "ICB vs NSG",
            "WN": "WT vs NSG",
            "NO": "NSG vs Output",
            "OI": "Output vs Input",
            "IW": "ICB vs WT",
            "IO": "ICB vs Output",
            "II": "ICB vs Input",
            "WO": "WT vs Output",
            "WI": "WT vs Input",
            "NI": "NSG vs Input"
        }
    }

const menuOptions = {
    g:{
        cl: {
            B:Object.keys(dict.conditionPair),
            C:Object.keys(dict.conditionPair),
            K:Object.keys(dict.conditionPair),
            L:Object.keys(dict.conditionPair),
            M:Object.keys(dict.conditionPair),
            P:Object.keys(dict.conditionPair),
            R:Object.keys(dict.conditionPair),
            Y:Object.keys(dict.conditionPair)
        },
        c: {
            IN: Object.keys(dict.cellLine),
            WN: Object.keys(dict.cellLine),
            NO: Object.keys(dict.cellLine),
            OI: Object.keys(dict.cellLine),
            IW: Object.keys(dict.cellLine),
            IO: Object.keys(dict.cellLine),
            II: Object.keys(dict.cellLine),
            WO: Object.keys(dict.cellLine),
            WI: Object.keys(dict.cellLine),
            NI: Object.keys(dict.cellLine)
        }
    },
    p:{
        cl: {
            B:Object.keys(dict.conditionPair),
            C:Object.keys(dict.conditionPair),
            K:Object.keys(dict.conditionPair),
            L:Object.keys(dict.conditionPair).filter(item=> !["WN", "IW", "WO", "WI"].includes(item)),
            M:Object.keys(dict.conditionPair),
            R:Object.keys(dict.conditionPair).filter(item=> !["NO", "OI", "IO", "WO"].includes(item))
        },
        c: {
            IN:["B", "C", "K", "L","M","R"], 
            WN: ["B", "C", "K", "M","R"],
            NO: ["B", "C", "K", "L","M"],
            OI: ["B", "C", "K", "L","M"],
            IW: ["B", "C", "K", "M","R"],
            IO: ["B", "C", "K", "L","M"],
            II: ["B", "C", "K", "L","M","R"],
            WO: ["B", "C", "K", "M"],
            WI: ["B", "C", "K", "M","R"],
            NI:["B", "C", "K", "L","M","R"]
        }
      
    },
    c:{
        cl: {
            B:Object.keys(dict.conditionPair),
            L:Object.keys(dict.conditionPair)
        },
        c: {
            IN: ["B", "L"],
            WN: ["B", "L"],
            NO: ["B", "L"],
            OI: ["B", "L"],
            IW: ["B", "L"],
            IO: ["B", "L"],
            II: ["B", "L"],
            WO: ["B", "L"],
            WI: ["B", "L"],
            NI: ["B", "L"]
        }
    },
    
}


    let userInput = {
        l: "g",
        c: "OI",
        cl: "B",
        c2:"NO",
        cl2:"B",
        scatter:false
    }
    let contextConfig = {
        baseUrl: "https://tide-data-server.uc.r.appspot.com/",
        rootId: "context-plots",
        padding:{top:60, right: 25, bottom:0, left:25}
    }
    let focusConfig = {
        baseUrl: "https://tide-data-server.uc.r.appspot.com/",
        rootId: "focus-plot",
        padding:{top:60, right: 30, bottom:40, left:30}
    }

export default {
    name: "DataPortal",
    mounted(){
        this.init()
    },
    methods: {
        init(){

                const createSelect = (dom, input) => {
                    let options = [];
                    input.forEach(function (item) {
                        var option = `<option value="${item.value}">${item.label}</option>`
                        options.push(option);
                    });
                    $(`${dom}`).html(options);
                }
                createSelect("select.l", Object.keys(dict.screenLibrary).map(d => { return { label: dict.screenLibrary[d], value: d } }))
                createSelect("select.c", Object.keys(dict.conditionPair).map(d => { return { label: dict.conditionPair[d], value: d } }))
                createSelect("select.cl", Object.keys(dict.cellLine).map(d => { return { label: dict.cellLine[d], value: d } }))

                createSelect("select.c2", Object.keys(dict.conditionPair).map(d => { return { label: dict.conditionPair[d], value: d } }))
                createSelect("select.cl2", Object.keys(dict.cellLine).map(d => { return { label: dict.cellLine[d], value: d } }))
               

                $("select.l").val(userInput.l); 
                $("select.c").val(userInput.c);
                $("select.cl").val(userInput.cl); 
                $("select.c2").val(userInput.c2); 
                $("select.cl2").val(userInput.cl2); 
                
                let setPlotTypeStatus = ()=>{
                    if (userInput.scatter == true){
                        $(`.scatterplotType`).removeClass("active")
                        $(`.scatterplotType`).filter(function(){  return this.value=="true" }).addClass("active")
                        $("#plot-instructions").html("To filter the data table, click and drag over an area in the large plot or search by gene name.<br><br>To see gene- and guide-level data, select a point in the large plot or a row in the data table.")
                        $("#comparison-menu").removeClass("dispayNone")  
                    } else {
                        $(`.scatterplotType`).removeClass("active")
                        $(`.scatterplotType`).filter(function(){ return this.value=="false"}).addClass("active")
                        $("#plot-instructions").html("To filter the data table, click and drag over an area in the large plot or search by gene name.<br><br>To see a gene, select a point in the large plot or a row in the data table.")
                        $("#comparison-menu").addClass("dispayNone") 
                    }
                }
                setPlotTypeStatus()
                $('#table').DataTable({
                    data: [],
                    // destroy:true,
                    columns: [
                        { data: 'series', title: "Gene"},
                        { data: "x", title: `Log2 (fold change)` },
                        { data: 'y',  title: `-Log10 (p value)` }
                    ],
                    // select: true,
                    language: {
                        search: "",
                        searchPlaceholder: "Search gene"
                    },
                    order: [[2, 'desc']],
                    paging: true,
                    deferRender:    true,
                    dom: 'f<"custom-pill">Brtip',
                    buttons: ['csv']
                });

                $('div.custom-pill').html('').addClass("hidden");

                tideDataPortal.launchContext(contextConfig, userInput)
                tideDataPortal.launchFocus(focusConfig, userInput)

                $("select.l").on("change", function () {
                    userInput.l = this.value;
                    // 1. update c
                    let available_c = find_available_c();
                    let is_c_available = find_is_it_available(available_c, userInput.c)
                    update_options(available_c, "c")
                    update_selected_c(is_c_available, "c")

                    let is_c2_available = find_is_it_available(available_c, userInput.c2)
                    update_options(available_c, "c2")
                    update_selected_c(is_c2_available, "c2")

                    // 2. update cl
                    let available_cl = find_available_cl(userInput.c);
                    let is_cl_available = find_is_it_available(available_cl, userInput.cl)
                    update_options(available_cl, "cl")
                    update_selected_cl(is_cl_available, "cl")

                    let available_cl2 = find_available_cl(userInput.c2);
                    let is_cl2_available = find_is_it_available(available_cl2, userInput.cl2)
                    update_options(available_cl2, "cl2")
                    update_selected_cl(is_cl2_available, "cl2")

                    tideDataPortal.launchContext(contextConfig, userInput)
                    tideDataPortal.launchFocus(focusConfig, userInput)

                })

                $("select.c").on("change", function () {
                    userInput.c = this.value;
                
                    let available_cl = find_available_cl(userInput.c);
                    let is_cl_available = find_is_it_available(available_cl, userInput.cl)
                    update_options(available_cl, "cl")
                    update_selected_cl(is_cl_available, "cl")

                    tideDataPortal.launchContext(contextConfig, userInput)
                    tideDataPortal.launchFocus(focusConfig, userInput)  
                })


                $("select.c2").on("change", function () {
                    userInput.c2 = this.value;

                    let available_cl = find_available_cl(userInput.c2);
                    let is_cl_available = find_is_it_available(available_cl, userInput.cl2)
                    update_options(available_cl, "cl2")
                    update_selected_cl(is_cl_available, "cl2")

                    tideDataPortal.launchFocus(focusConfig, userInput)
                })
                $("select.cl").on("change", function () {
                    userInput.cl = this.value;
                    tideDataPortal.launchFocus(focusConfig, userInput)
                })
                $("select.cl2").on("change", function () {
                    userInput.cl2 = this.value;
                    tideDataPortal.launchFocus(focusConfig, userInput)
                })

                $("button.scatterplotType").on("click", function () {
                    if (this.value == "false"){ 
                        userInput.scatter = false;
                        setPlotTypeStatus();
                    } 
                    else { 
                        userInput.scatter = true;
                        setPlotTypeStatus();
                    }

                    tideDataPortal.launchContext(contextConfig, userInput)
                    tideDataPortal.launchFocus(focusConfig, userInput)
                })

                function update_options(available, elementClass){
                    document.querySelectorAll(`.${elementClass} option`).forEach(opt => {
                        if (available.includes(opt.value)) {
                            opt.disabled = false;
                        } else {
                            opt.disabled = true;
                        }
                    }); 
                }
                function find_available_c(){
                    return Object.keys(menuOptions[ userInput.l].c);
                }
                function find_available_cl(key){
                    return menuOptions[ userInput.l].c[key];
                }
                function find_is_it_available(available, selected){
                    return available.includes(selected);
                }
                function update_selected_cl(is_available, key){
                    let c;
                    if (key=="cl"){ c = "c" }
                    else { c= "c2"}

                    if (is_available){
                        return
                    } else {
                       // alert (`${dict.cellLine[userInput[key]]} is not available for ${dict.screenLibrary[userInput.l]}-${dict.conditionPair[userInput[c]]}`)
                        userInput[key] = menuOptions[userInput.l].c[userInput[c]][0]
                        $(`.${key}`).val(userInput[key])
                    }
                }
                function update_selected_c(is_available, key){
                    if (is_available){
                        return
                    } else {
                        userInput[key] = Object.keys(menuOptions[userInput.l].c)[0]
                        $(`.${key}`).val(userInput[key])
                    }
                }
        }
    }
};
</script>

<style scoped>
.dispayNone{
    display:none;
}
</style>